import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-40a6d710"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tgSearchContainer" }
const _hoisted_2 = { class: "el-dropdown-link" }

import { Search } from "@element-plus/icons-vue";
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import { ref, computed } from "vue";
import { TgActions, TgGetters, TgMutations, } from "@/store/modules/telegram";
import { ArrowDown } from '@element-plus/icons-vue'

import { defineComponent } from "vue";
const __default__ = defineComponent({
    name: "TgSearch"
}
);


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute();
const store = useStore();

const projectId = computed(() => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0])
const targetId = computed(() => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]);
const tgIdCom = computed(() => {
    return store.getters[`telegram/${TgGetters.getMeId}`];
});
const searchType = computed(() => {
    return store.getters[`telegram/${TgGetters.getSearchType}`];
});
const handleCommand = (command: string) => {
    store.commit(`telegram/${TgMutations.setSearchType}`, command);
    if (searchInput.value !== '') {
        asyncGetTarget()
    }
}

const searchInput = ref<string>("")

const asyncGetTarget = async () => {
    const projId = projectId.value;
    let uid = targetId.value
    let target = searchInput.value
    let tgId = tgIdCom.value

    store.commit(`telegram/${TgMutations.setSelectMenu}`, '4');
    store.commit(`telegram/${TgMutations.setSearchTarget}`, target);
    store.commit(`telegram/${TgMutations.resetSearch}`);

    if (searchType.value === '用户') {
        store.dispatch(`telegram/${TgActions.asyncGetSearchingChatByUidAndTgId}`, { projId: projId, uid: uid, tgId: tgId, isAppend: false, target: target });
    } else {
        if (searchType.value === '精确') {
            target = "^" + target + "$"
        }
        store.dispatch(`telegram/${TgActions.asyncGetSearchingContactByUidAndTgId}`, { projId: projId, uid: uid, tgId: tgId, isAppend: false, target: target });
        store.dispatch(`telegram/${TgActions.asyncGetSearchingConvByUidAndTgId}`, { projId: projId, uid: uid, tgId: tgId, isAppend: false, target: target });
    }
}



return (_ctx: any,_cache: any) => {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dropdown, { onCommand: handleCommand }, {
      dropdown: _withCtx(() => [
        _createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_dropdown_item, { command: "模糊" }, {
              default: _withCtx(() => [
                _createTextVNode("模糊查询(支持正则)")
              ]),
              _: 1
            }),
            _createVNode(_component_el_dropdown_item, { command: "精确" }, {
              default: _withCtx(() => [
                _createTextVNode("精确查询")
              ]),
              _: 1
            }),
            _createVNode(_component_el_dropdown_item, { command: "用户" }, {
              default: _withCtx(() => [
                _createTextVNode("用户查询")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, [
          (_unref(searchType) !== '')
            ? (_openBlock(), _createBlock(_component_el_text, { key: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(searchType)), 1)
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_el_text, { key: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode("模糊")
                ]),
                _: 1
              })),
          _createVNode(_component_el_icon, { class: "el-icon--right" }, {
            default: _withCtx(() => [
              _createVNode(_unref(ArrowDown))
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_input, {
      modelValue: searchInput.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchInput).value = $event)),
      placeholder: "搜索",
      onKeydown: _withKeys(asyncGetTarget, ["enter"])
    }, null, 8, ["modelValue", "onKeydown"]),
    _createVNode(_component_el_button, {
      icon: _unref(Search),
      onClick: asyncGetTarget
    }, null, 8, ["icon"])
  ]))
}
}

})